import React from 'react'

import ChallengePage from './ChallengePage'
import { StudentsDashboard } from '../components/users/students'
import StudentRoutine from '../components/users/students/Dashboard/Routine'
import { DashboardContainer } from '../components/users/students/Dashboard/styles'
import ProfessorBio from '../components/users/students/Professor'
// import Dashboard from '../redesign/pages/Dasboard/Dashboard'

import { InternalContent } from './styles'

const StudentsPage = ({ part, type }: { part: string; type?: string }) => {
  const getPart = () => {
    switch (part) {
      case 'dashboard':
        return <StudentsDashboard type={type} />
      case 'profesor':
        return <ProfessorBio />
      case 'rutina':
        return <StudentRoutine />
      case 'admin-challenge':
        return <ChallengePage />
      case 'chat':
        return <div>Chat</div>
      case 'opinion':
        return <div>Opinion</div>
      default:
        return <div>Default</div>
    }
  }
  return (
    <InternalContent style={{ overflowY: 'scroll' }}>
      <DashboardContainer>{getPart()}</DashboardContainer>
    </InternalContent>
    // <Dashboard />
  )
}

export default StudentsPage
